(function () {
  'use strict';

  var colorMap = {
    merlot:  '#7b3245',
    soil:    '#884a31',
    mud:     '#8d8671',
    sand:    '#c6b199',
    cheddar: '#f69322',
    red:     '#eb242a',
    reef:    '#07a89c',
    pond:    '#4686c6'
  };

  function isMobile() {
    return window.matchMedia('(max-width: 47.999rem)').matches;
  }

  function init() {
    var wordmarks = document.querySelectorAll('[data-footer-wordmark]');
    wordmarks.forEach(function (wordmark) {
      if (wordmark.dataset.wordmarkInit) return;
      wordmark.dataset.wordmarkInit = 'true';

      wordmark.querySelectorAll('[data-letter]').forEach(function (letter) {
        var colorName = letter.getAttribute('data-color');
        var brandColor = colorMap[colorName] || '#ffffff';
        var resetTimer = null;

        letter.addEventListener('mouseenter', function () {
          if (isMobile()) return;
          clearTimeout(resetTimer);
          letter.style.fill = brandColor;
        });

        letter.addEventListener('mouseleave', function () {
          if (isMobile()) return;
          resetTimer = setTimeout(function () {
            letter.style.fill = '';
          }, 600);
        });
      });
    });
  }

  init();

  // Hot reload / theme editor: section DOM is replaced in place, and the
  // re-inserted <script> tag does NOT re-execute. Re-init on each load.
  document.addEventListener('shopify:section:load', init);
})();
